<template>
  <div class="table-wrapper-scroll-y app-scroll-table">
    <table class="table table-striped table-bordered table-condensed">
      <thead>
        <tr>
          <th><div class="text-center">Global IPv4 Address</div></th>
          <th><div class="text-center">Mapped IPv6 Address</div></th>
          <th><div class="text-center">Status</div></th>
          <th><div class="text-center">VM Name</div></th>
          <th><div class="text-center">VM Owner</div></th>
          <th><div class="text-center">Operation</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="`nat46-${row.id}`">
          <td><div class="text-center">{{ row.ipv4 }}</div></td>
          <td><div class="text-center">{{ row.ipv6 }}</div></td>
          <td>
            <div class="text-center">
              <span class="app-status-chip" :class="row.status_class">{{ row.status_label }}</span>
            </div>
          </td>
          <td><div class="text-center">{{ row.vm_name }}</div></td>
          <td><div class="text-center">{{ row.vm_owner }}</div></td>
          <td>
            <div class="text-center app-action-buttons">
              <a
                v-if="row.actions?.edit_url"
                :href="row.actions.edit_url"
                title="NAT46 Mapping"
                class="btn btn-sm btn-outline-primary app-action-btn app-action-btn--primary"
              >
                <AppIcon name="edit" />
              </a>
              <button
                v-if="row.actions?.destroy_url"
                type="button"
                class="btn btn-sm btn-danger app-action-btn app-action-btn--danger"
                title="Delete NAT46 Address"
                @click="handleDelete(row)"
              >
                  <AppIcon name="delete" />
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import AppIcon from './AppIcon.vue'

const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({ rows: [] })
  }
})

const rowsState = ref(props.initialData?.rows || [])
const rows = computed(() => rowsState.value)
const csrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content") || ""

function sccShowToast(level, message) {
  window.sccStatusShell?.sccShowToast?.(level, message)
}

async function handleDelete(row) {
  const actions = row.actions || {}
  if (!actions.destroy_url) {
    return
  }

  if (actions.destroy_confirm_message && !window.confirm(actions.destroy_confirm_message)) {
    return
  }

  try {
    const payload = await requestJson(actions.destroy_url, { method: 'DELETE' })
    if (payload?.level && payload?.message) {
      sccShowToast(payload.level, payload.message)
    }

    rowsState.value = rowsState.value.filter((entry) => String(entry.id) !== String(row.id))
  } catch (error) {
    sccShowToast('danger', error.message || 'Failed to delete NAT46 mapping.')
  }
}

async function requestJson(url, options = {}) {
  const method = (options.method || 'GET').toUpperCase()
  const headers = {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    ...(options.headers || {})
  }
  const fetchOptions = {
    method,
    headers,
    credentials: 'same-origin'
  }

  if (csrfToken && method !== 'GET' && method !== 'HEAD') {
    headers['X-CSRF-Token'] = csrfToken
  }

  const response = await fetch(url, fetchOptions)
  const text = await response.text()
  let payload = null

  if (text) {
    try {
      payload = JSON.parse(text)
    } catch {
      payload = null
    }
  }

  if (!response.ok) {
    throw new Error((payload && payload.message) || text || 'Request failed.')
  }

  return payload
}
</script>
